import React, { memo } from 'react'
import TextField from "@mui/material/TextField";
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';

const UiInput = memo((props) => {
    const { label, name, type, error, placeholder, multiline, maxRows ,minRows, onInput,value } = props;

    const [showPassword, setShowPassword] = React.useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <>
            <FormControl
                error={error}
                sx={{ mb: 2 }}
                variant="outlined"
                fullWidth 
                >

                <InputLabel
                    htmlFor={name}
                >{label}</InputLabel>
                {type == 'password' ?
                    <OutlinedInput
                        id={name}
                        type={showPassword ? 'text' : 'password'}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        }
                        value={value? value :''}
                        label={label}
                        placeholder={placeholder}
                        
                                           
                    />
                    :
                    <OutlinedInput
                        id={name}
                        type={type}
                        label={label}
                        placeholder={placeholder}
                        multiline={multiline}
                        maxRows={maxRows}
                        minRows={minRows}
                        onInput={onInput}
                    />
                }
                {error &&
                    <FormHelperText id="component-error-text">Error</FormHelperText>
                }
            </FormControl>

        </>

    )

})

export default UiInput